import { useMutationCardForm } from 'forms/mutation/useMutationCardForm';
import type { useUpdateMutationForm } from 'forms/mutation/useUpdateMutationForm';
import {
  cardsToShareSeries,
  getSeriesDataCardSchema,
  shareSeriesToCards,
} from 'mutations/seriesDataCards';
import { isShareSeriesMutation, shareSeriesMutationTypes } from 'mutations/shareSeries';

/**
 * The issuance mutation form is the same as the update mutation form, but has specific defaults for the issuance mutation.
 * It will automatically map the mutation to the cards field.
 * @param props
 * @returns
 */
const useSeriesDataMutationForm = ({
  mutation,
  ...props
}: Omit<
  Parameters<typeof useUpdateMutationForm>[0],
  | 'formInputMapper'
  | 'mutationType'
  | 'mutationField'
  | 'mutationSchema'
  | 'schema'
  | 'replaceValidationPart'
  | 'defaultValues'
>) => {
  if (!isShareSeriesMutation(mutation)) {
    throw new Error(
      `The mutation is not a valid mutation for this form. It must must be of type: ${shareSeriesMutationTypes.join(
        ', ',
      )}.`,
    );
  }

  return useMutationCardForm({
    ...props,
    mutation,
    mutationType: mutation.type,
    cardsToMutationSeries: cardsToShareSeries,
    mutationSeriesToCards: shareSeriesToCards,
    cardSchema: getSeriesDataCardSchema(),
  });
};

export { useSeriesDataMutationForm };
